export class JobProgressStepGroupDirectoryRestorationData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "groupEmail",
            "baseName": "groupEmail",
            "type": "string",
            "format": ""
        },
        {
            "name": "groupId",
            "baseName": "groupId",
            "type": "string",
            "format": ""
        },
        {
            "name": "consoleUrl",
            "baseName": "consoleUrl",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepGroupDirectoryRestorationData.attributeTypeMap;
    }
    constructor() {
    }
}
